import { ThunkAction } from 'redux-thunk';
import { camelToSnakeCase } from 'json-style-converter/es5';
import { RentalFormActionTypes } from './types';
import AppState from '../../types/AppState';
import service from '../../api/service';
import { ROOT_URL } from '../../api';
import { buildRentalVersionNormalizePayload } from '../../helper_functions/rentalForm/buildRentalVersionNormalizePayload';
import RentalVersionData from '../../types/RentalVersionData';

/**
 * Calls the backend normalization endpoint if a relevant field changed.
 * @param payload The payload (partial RentalVersionData) that was changed
 */
export const normalizeCurrentRentalVersion = (
  payload: Partial<RentalVersionData>
): ThunkAction<
  Promise<void>,
  AppState,
  unknown,
  RentalFormActionTypes
> => async (dispatch, getState) => {
  // Manually check for fields that should trigger normalization
  const shouldNormalize =
    (payload.scheduleAttributes &&
      payload.scheduleAttributes.eventStartDateTime !== undefined) ||
    payload.deliveryType !== undefined ||
    payload.deliveryAddressStreetAddress1 !== undefined ||
    payload.deliveryAddressStreetAddress2 !== undefined ||
    payload.deliveryAddressCity !== undefined ||
    payload.deliveryAddressLocale !== undefined ||
    payload.deliveryAddressPostalCode !== undefined ||
    payload.deliveryAddressCountry !== undefined ||
    payload.customExpireDate !== undefined;

  if (!shouldNormalize) return;

  const { data } = getState().rentalFormV2;

  const payloadToSend = buildRentalVersionNormalizePayload(data);

  const response = await service.post(`${ROOT_URL}/rental_versions/normalize`, {
    rental_version: camelToSnakeCase(payloadToSend),
    rental_id: getState().rentalFormV2.rentalId,
  });

  dispatch({
    type: 'UPDATE_RENTAL_FORM_V2_SUCCESS',
    payload: response.data,
  });
};
